import { ClickAwayListener, MenuItem, Paper, Popper } from '@mui/material';
import { CalendarCategoryOption } from './calendarConfig';
import { calendarUiPalette } from './calendarPalette';

interface CalendarNewEntryMenuProps {
  anchorEl: HTMLElement | null;
  categories: readonly CalendarCategoryOption[];
  onClose: () => void;
  onSelectCategory: (categoryKey: CalendarCategoryOption['key']) => void;
}

export default function CalendarNewEntryMenu({
  anchorEl,
  categories,
  onClose,
  onSelectCategory,
}: Readonly<CalendarNewEntryMenuProps>) {
  return (
    <Popper
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      placement="bottom-end"
      disablePortal={false}
      modifiers={[
        {
          name: 'offset',
          options: {
            offset: [0, 10],
          },
        },
        {
          name: 'preventOverflow',
          enabled: true,
          options: {
            padding: 12,
          },
        },
      ]}
      sx={{ zIndex: 1400 }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <Paper
          data-cy="calendar-new-entry-menu"
          elevation={8}
          sx={{
            minWidth: 220,
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: calendarUiPalette.shadows.menu,
          }}
        >
          {categories.map((category) => (
            <MenuItem
              key={category.key}
              onClick={() => onSelectCategory(category.key)}
              data-cy={`calendar-new-entry-option-${category.key}`}
            >
              {category.label}
            </MenuItem>
          ))}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
}
